/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <LoadScreen v-if="mostrarLoader"></LoadScreen>
    <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito"></ModalExito>
    <ModalError v-if="mostrarError" :mostrarError="mostrarError"></ModalError>

    <ModalBase v-if="mostrarModal">
        <section class="contenedorPrincipal">
            <section>
                <div class="titulo">{{ tituloHeader }}</div>
                <div class="separador"></div>
            </section>

            <div class="form-group">
                <div class="label">Folio/ID de Usuario:</div>
                <input class="inputEditarNumEmp" type="text" maxlength="20" id="numeroEmpleado"
                    :value="String(idUsuario).padStart(4, '0')" readonly />
            </div>

            <div class="form-group">
                <div class="label">Nombre:</div>
                <input class="inputEditar" type="text" maxlength="100" v-model="nombre" />
            </div>

            <div class="form-group">
                <div class="label">Apellido paterno:</div>
                <input class="inputEditar" type="text" maxlength="100" v-model="apellidoPaterno" />
            </div>

            <div class="form-group">
                <div class="label">Apellido materno:</div>
                <input class="inputEditar" type="text" maxlength="100" v-model="apellidoMaterno" />
            </div>

            <div class="form-group">
                <div class="label">Correo:</div>
                <input class="inputEditar" type="email" maxlength="40" v-model="correo" />
            </div>

            <section class="contenedorBotones">
                <Button class="btn-regresar" @click="cancelar">Regresar</Button>
                <Button class="btn-guardar" @click="guardarCambios">Guardar</Button>
            </section>
        </section>
    </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from '../Forms/LoadScreen.vue';
import userService from '@/services/userService';

export default {
    components: {
        Button,
        ModalBase,
        ModalExito,
        ModalError,
        LoadScreen,
    },
    props: {
        tituloHeader: {
            type: String,
            default: "Editar Administrador",
        },
        admin: {
            type: Object,
            required: true
        }
    },
    data() {
        const initialAdmin = this.admin;
        return {
            showAddProducto: false,
            mostrarLoader: false,
            mostrarModal: true,
            mostrarExito: false,
            mostrarError: false,
            idUsuario: initialAdmin.id_usuario || '',
            nombre: initialAdmin.nombre || '',
            apellidoPaterno: initialAdmin.ape_pat || '',
            apellidoMaterno: initialAdmin.ape_mat || '',
            correo: initialAdmin.correo || '',
            telefono: initialAdmin.telefono || '',
            domicilio: initialAdmin.domicilio || '',
            rol: initialAdmin.rol ? initialAdmin.rol.nombre : 'Administrador',
            claveNueva: '',
        };
    },
    emits: ["cancelar", "actualizado"],
    methods: {
        mostrarAddService() {
            this.showAddProducto = true;
        },
        ocultarAddProd() {
            this.showAddProducto = false;
        },
        cancelar() {
            this.$emit("cancelar");
        },
        generarNuevaClave() {
            this.claveNueva = 'NuevaClaveSegura123';
            console.log('Nueva clave generada:', this.claveNueva);
        },
        async guardarCambios() {
            this.mostrarModal = false;
            this.mostrarLoader = true;

            const payload = {
                nombre: this.nombre,
                ape_pat: this.apellidoPaterno,
                ape_mat: this.apellidoMaterno,
                correo: this.correo,
                telefono: this.telefono,
                domicilio: this.domicilio,
                ...(this.claveNueva && { contraseña: this.claveNueva }),
            };

            const userId = this.idUsuario;

            try {
                const response = await userService.updateUser(userId, payload);
                console.log('Administrador actualizado con éxito', response.data);
                this.mostrarLoader = false;
                this.mostrarExito = true;
                this.mostrarModal = false;
                this.$emit('actualizado');

                setTimeout(() => {
                    this.mostrarExito = false;
                }, 2000);

            } catch (error) {
                console.error('Error al actualizar el administrador:', error.response ? error.response.data : error.message);
                this.mostrarLoader = false;
                this.mostrarError = true;
                setTimeout(() => {
                    this.mostrarError = false;
                }, 2000);
            }
        },
    },
};
</script>

<style scoped>

.contenedorPrincipal {
    margin: 0px 30px;
    padding-bottom: 20px;
}

.titulo {
    padding: 30px 0px 10px 0px;
    font-size: 28px;
    font-weight: 600;
    color: #333;
    word-wrap: break-word;
}

.separador {
    border-top: 3px solid #2a428c;
    height: 2px;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 25px;
    opacity: 0.9;
}

.form-group {
    margin-bottom: 15px;
}

.label {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
    color: #444;
}

.inputEditar,
.inputEditarNumEmp {
    width: 100%;
    max-width: 350px;
    height: 38px;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 0px 10px;
    font-size: 14px;
    color: #333;
    outline: none;
    box-sizing: border-box;
    transition: all 0.3s ease;
}

.inputEditarNumEmp {
    background-color: #e8e5e5;
    user-select: none;
    color: #666;
    border-color: #d1d1d1;
}

.inputEditar:focus {
    outline: none;
    border-color: #29b9f6;
    box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.contrasenaInput {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
}

.label-pass {
    font-weight: 500;
    color: #444;
}

.btn-GenNewPass {
    font-size: 13px;
    padding: 8px 15px;
}

.contenedorBotones {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 35px;
    width: 100%;
}

@media (max-width: 768px) {
    .contenedorPrincipal {
        margin: 0px 15px;
    }

    .titulo {
        font-size: 22px;
        padding-top: 20px;
        text-align: left;
    }

    .separador {
        margin-bottom: 20px;
    }

    .label {
        font-size: 15px;
        margin-top: 10px;
    }

    .inputEditar,
    .inputEditarNumEmp {
        max-width: 100%;
        height: 42px;
        font-size: 16px;
        padding: 0px 12px;
    }

    .contrasenaInput {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .btn-GenNewPass {
        width: 100%;
        justify-content: center;
        height: 40px;
    }

    .contenedorBotones {
        margin-top: 25px;
        gap: 15px;
    }
}
</style>